import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { TipoRevisionService } from '../tipo-revision.service';

@Component({
  selector: 'app-tipo-revision-view',
  templateUrl: './tipo-revision-view.component.html',
  styleUrls: ['./tipo-revision-view.component.scss']
})
export class TipoRevisionViewComponent implements OnInit {

  @Input() element: any = null;
  form: FormGroup = new FormGroup({});

  constructor(
    private formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public service: TipoRevisionService,
    public formatter: FormatterService
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      id: ['', [Validators.required]],
      nombre: ['', [Validators.required]],
      descripcion: [''],
    });

    this.form.patchValue(this.element);
    this.form.disable();
  }

}
